<template>
   <v-layout>
       <v-flex transition="slide-x-transition" class="login-error" v-html="error" data-qe-id="login-error">
       </v-flex>
   </v-layout>
</template>
<script>
    import { mapGetters } from 'vuex';
    import { storeGetters } from "../../store/storeGetters.constant";

    export default {
        name: "LoginError",
        computed: {
            ...mapGetters({
                error: `auth/${storeGetters.getLoginError}`,
            }),
        },
    };
</script>
<style lang="scss" scoped>
    @import '../../common/styles/_colors.scss';

    .login-error {
        color: $ypo-error-red;
        padding-bottom: 10px;
    }
</style>
